import React from "react";
import CoursePageSectoin from "../../Sections/CoursePageSection/Content";
const CoursePage = () => {
  return <CoursePageSectoin />;
};

export default CoursePage;
